import React, {Component, useEffect, useState} from 'react';
import ListDesignerHoc from "../../../../HocHelpers/ListDesignerHoc";
import LineRechart from "./ChartTypes/LineRechart";
import BarRechart from "./ChartTypes/BarRechart";
import PieRechart from "./ChartTypes/PieRechart";
import ComposedRechart from "./ChartTypes/ComposedRechart";
import {useSelector} from "react-redux";
import PieNarrowRechart from "./ChartTypes/PieNarrowRechart";

const Charts = (props) => {
    const {data: {chartProps: {type} = {}} = {},
        pivotColumns, pivotData, sort, paged
    } = props;
    const {userLanguage} = useSelector(state => state.app);
    switch (type) {
        case 'barRechart':
            return <BarRechart
                pivotColumns={pivotColumns}
                pivotData={pivotData}
                sort={sort}
                paged={paged}
                userLanguage={userLanguage}
            />;
        case 'lineRechart':
            return <LineRechart
                pivotColumns={pivotColumns}
                pivotData={pivotData}
                sort={sort}
                paged={paged}
                userLanguage={userLanguage}
            />;
        case 'pieRechart':
            return <PieRechart
                pivotColumns={pivotColumns}
                pivotData={pivotData}
                sort={sort}
                paged={paged}
                userLanguage={userLanguage}
            />;
        case 'pieNarrowRechart':
            return <PieNarrowRechart
                pivotColumns={pivotColumns}
                pivotData={pivotData}
                sort={sort}
                paged={paged}
                userLanguage={userLanguage}
            />;
        case 'composedRechart':
            return <ComposedRechart
                pivotColumns={pivotColumns}
                pivotData={pivotData}
                sort={sort}
                paged={paged}
                userLanguage={userLanguage}
            />;
        default:
            return (
                <span style={{textAlign: 'center', fontSize: '1.2rem', marginTop: 10}}>
                    Select chart type
                </span>
            )
    }
}

export default ListDesignerHoc(Charts)

